var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"currentColor","points":"25,3.4 24.3,4.1 28.9,8.7 1.8,8.7 1.8,9.7 28.9,9.7 24.3,14.3 25,15 30.9,9.2"}));
}

ArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32.6 18.4","xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
